import React from "react";

const FormField = props => 
    <div className={[...props.formFieldClass, 'form_fields'].join(' ')}>
        {((props.title && props.title !== '') || props.titleClass) && <div className={[...props.titleClass, 'data_label'].join(' ')}>{props.title}</div>}
        {props.children}
    </div>;

export default FormField;